module.exports = __webpack_public_path__ + "img/008cad1.png";